export const PLATFORM_SHELL_BUSY_OVERLAY_CSS = `
.platform-shell-busy-overlay {
  position: fixed;
  inset: 0;
  z-index: 2147483200;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 18px;
  background: rgba(3, 10, 24, 0.58);
  backdrop-filter: blur(14px) saturate(1.08);
  -webkit-backdrop-filter: blur(14px) saturate(1.08);
  pointer-events: none;
  animation: platformShellBusyOverlayFade 180ms ease-out;
}
.platform-shell-busy-overlay__card {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  align-items: center;
  gap: 18px;
  width: min(540px, calc(100vw - 48px));
  min-height: 156px;
  padding: 18px 22px;
  border-radius: 20px;
  border: 1px solid rgba(125, 211, 252, 0.34);
  background:
    radial-gradient(circle at 18% 20%, rgba(96, 165, 250, 0.32), transparent 38%),
    radial-gradient(circle at 90% 0%, rgba(56, 189, 248, 0.18), transparent 42%),
    linear-gradient(135deg, rgba(30, 58, 104, 0.98), rgba(11, 31, 65, 0.98) 54%, rgba(5, 21, 48, 0.98));
  box-shadow:
    0 24px 56px rgba(2, 8, 23, 0.42),
    inset 0 1px 0 rgba(219, 234, 254, 0.18),
    inset 0 0 0 1px rgba(147, 197, 253, 0.16);
  color: #eaf6ff;
  overflow: visible;
  isolation: isolate;
  animation: platformShellBusyOverlayRise 180ms ease-out;
}
.platform-shell-busy-overlay__visual {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 96px;
  flex: 0 0 96px;
  border-radius: 999px;
  background:
    radial-gradient(circle at 35% 32%, rgba(255, 255, 255, 0.14), transparent 36%),
    linear-gradient(180deg, rgba(31, 63, 111, 0.62), rgba(15, 33, 68, 0.9));
  box-shadow:
    0 0 36px rgba(56, 189, 248, 0.22),
    inset 0 0 0 16px rgba(96, 165, 250, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.12);
}
.platform-shell-busy-overlay__visual--countdown {
  width: 96px;
  height: 96px;
}
.platform-shell-busy-overlay__halo,
.platform-shell-busy-overlay__pulse,
.platform-shell-busy-overlay__core {
  position: absolute;
  border-radius: 999px;
  pointer-events: none;
}
.platform-shell-busy-overlay__halo {
  inset: 8px;
  border: 8px solid transparent;
  color: #4ee7f8;
  border-left-color: currentColor;
  border-top-color: currentColor;
  filter: drop-shadow(0 0 10px currentColor);
  animation: platformShellBusyOverlayOrbit 1.35s linear infinite;
}
.platform-shell-busy-overlay__pulse {
  inset: 8px;
  border: 8px solid transparent;
  color: #f8be83;
  border-bottom-color: currentColor;
  filter: drop-shadow(0 0 10px currentColor);
  animation: platformShellBusyOverlayOrbit 2.1s linear infinite;
}
.platform-shell-busy-overlay__core {
  inset: 29px;
  background:
    radial-gradient(circle at 35% 30%, rgba(255, 255, 255, 0.16), transparent 42%),
    linear-gradient(180deg, rgba(16, 38, 76, 0.86), rgba(9, 28, 58, 0.96));
  border: 1px solid rgba(147, 197, 253, 0.28);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
}
.platform-shell-busy-overlay__icon {
  position: relative;
  z-index: 2;
  width: 32px;
  height: 32px;
  color: #a8d8ff;
  filter: drop-shadow(0 0 12px rgba(96, 165, 250, 0.34));
  animation: platformShellBusyOverlayPulse 1.8s ease-in-out infinite alternate;
}
.platform-shell-busy-overlay__countdown {
  position: absolute;
  right: 0;
  bottom: 4px;
  z-index: 3;
  min-width: 38px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 999px;
  border: 1px solid rgba(125, 211, 252, 0.38);
  background: rgba(2, 8, 23, 0.62);
  color: #e0f2fe;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.26), inset 0 1px 0 rgba(255, 255, 255, 0.12);
  font-size: 0.67rem;
  font-weight: 800;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}
.platform-shell-busy-overlay__copy {
  display: grid;
  gap: 10px;
  min-width: 0;
}
.platform-shell-busy-overlay__title {
  display: block;
  font-size: clamp(0.98rem, 1.18rem, 1.18rem);
  font-weight: 900;
  line-height: 1.15;
  color: #ffffff;
  letter-spacing: 0;
  text-shadow: 0 2px 6px rgba(2, 8, 23, 0.32);
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  overflow-wrap: anywhere;
}
.platform-shell-busy-overlay__detail {
  display: block;
  font-size: clamp(0.78rem, 0.92rem, 0.92rem);
  line-height: 1.35;
  color: rgba(226, 240, 255, 0.78);
  overflow: visible;
  overflow-wrap: anywhere;
}
.platform-shell-busy-overlay__progress {
  position: relative;
  width: 100%;
  height: 7px;
  border-radius: 999px;
  overflow: hidden;
  background: rgba(96, 165, 250, 0.16);
  box-shadow: inset 0 1px 2px rgba(2, 8, 23, 0.32);
}
.platform-shell-busy-overlay__progress-fill {
  position: absolute;
  inset-block: 0;
  left: -38%;
  width: 46%;
  border-radius: inherit;
  background: linear-gradient(90deg, rgba(59, 130, 246, 0.88), rgba(78, 231, 248, 0.96));
  box-shadow: 0 0 14px rgba(78, 231, 248, 0.5);
  animation: platformShellBusyOverlayProgress 1.9s ease-in-out infinite;
}
.platform-shell-busy-overlay__status {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: rgba(226, 240, 255, 0.76);
  font-size: 0.88rem;
  line-height: 1.2;
}
.platform-shell-busy-overlay__status-icon {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  border-radius: 999px;
  border: 3px solid rgba(78, 231, 248, 0.28);
  border-top-color: #4ee7f8;
  animation: platformShellBusyOverlayOrbit 0.92s linear infinite;
}
.platform-shell-busy-overlay__status-text {
  min-width: 0;
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
  overflow-wrap: anywhere;
}
.platform-shell-busy-overlay__dots {
  display: inline-flex;
  gap: 8px;
  margin-left: auto;
  flex: 0 0 auto;
}
.platform-shell-busy-overlay__dots span {
  width: 9px;
  height: 9px;
  border-radius: 999px;
  background: #60a5fa;
  box-shadow: 0 0 12px rgba(96, 165, 250, 0.42);
  animation: platformShellBusyOverlayDot 1.25s ease-in-out infinite;
}
.platform-shell-busy-overlay__dots span:nth-child(2) {
  animation-delay: 160ms;
}
.platform-shell-busy-overlay__dots span:nth-child(3) {
  animation-delay: 320ms;
  opacity: 0.48;
}
`;

export const PLATFORM_SHELL_BUSY_OVERLAY_ICON = `
  <svg class="platform-shell-busy-overlay__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M8.8 4.4c-2.73 0-4.98 2.17-4.98 4.86 0 1.54.68 2.97 1.89 3.9.5.39.8.98.86 1.6l.03.39c.08.83.77 1.46 1.59 1.46h1.08V4.57c-.15-.01-.31-.02-.47-.02Zm6.4 0c-.16 0-.32.01-.47.02v12.19h1.08c.82 0 1.51-.63 1.59-1.46l.03-.39c.06-.62.36-1.21.86-1.6a4.87 4.87 0 0 0 1.89-3.9c0-2.69-2.25-4.86-4.98-4.86Z" fill="currentColor" fill-opacity="0.18"></path>
    <path d="M8.8 4.4c-2.73 0-4.98 2.17-4.98 4.86 0 1.54.68 2.97 1.89 3.9.5.39.8.98.86 1.6l.03.39c.08.83.77 1.46 1.59 1.46h1.08V4.57c-.15-.01-.31-.02-.47-.02Zm6.4 0c-.16 0-.32.01-.47.02v12.19h1.08c.82 0 1.51-.63 1.59-1.46l.03-.39c.06-.62.36-1.21.86-1.6a4.87 4.87 0 0 0 1.89-3.9c0-2.69-2.25-4.86-4.98-4.86Z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"></path>
    <path d="M10.05 7.1c-.92.62-1.55 1.67-1.55 2.87M13.95 7.1c.92.62 1.55 1.67 1.55 2.87M12 5.34v13.42M8.95 11.98h6.1M9.62 19.46h4.76M10.3 20.9h3.4" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
    <circle cx="8.15" cy="6.82" r="1.05" fill="#fef3c7"></circle>
    <circle cx="15.85" cy="6.82" r="1.05" fill="#a7f3d0"></circle>
  </svg>
`;
